// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import TerceraEventLogTemplate from '@front/templates/TerceraEventLogTemplate.html';
import { PanelNames } from '../UtilsClasses/FactoryConstants';
import { WINDOW_SIDE_BORDERS_WIDTH } from '../UtilsClasses/SizeConstants';
import { Control } from './Control';
import { PanelDisplayMode } from '@shared/commons/CustomerAccess/PanelDisplayMode';
import { CustomerAccess } from '@shared/commons/CustomerAccess/CustomerAccess';
import { Factory } from '../panels/Factory';
import { WorkSpaceManager } from '../WorkSpace/WorkSpaceManager';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { ContainerControl } from './ContainerControl';
export class TerceraEventLog extends ContainerControl {
    constructor() {
        super(...arguments);
        this.onEventLogClicked = () => {
            var _a;
            if (isNullOrUndefined(this.myEventLog)) {
                this.initializeEventLogPanel();
            }
            else {
                this.myEventLog.set('visible', !this.myEventLog.get('visible'));
            }
            if ((_a = this.myEventLog) === null || _a === void 0 ? void 0 : _a.get('visible')) {
                this.myEventLog.setFocus();
                this.checkSize();
            }
        };
    }
    getType() {
        return 'TerceraEventLog';
    }
    oncomplete() {
        super.oncomplete();
        WorkSpaceManager.OnWorkSpaceChanged.Subscribe(this.eventLogReinit, this);
        this.on('eventLogClick', this.onEventLogClicked);
        window.addEventListener('resize', this.checkSize.bind(this));
        this.completed = true;
    }
    initializeEventLogPanel() {
        this.myEventLog = Factory.createPanel(PanelNames.EventsPanel);
        this.myEventLog.OnClose.Subscribe(() => {
            this.cleanupEventLogPanel();
        });
        this.myEventLog.set('visibleChangedCallback', (visible) => {
            void this.set({ isEventLogOpened: visible });
        });
        MainWindowManager.AddControl(this.myEventLog);
        void this.set({ isEventLogOpened: true });
        this.setEventPanelPos();
        Control.Ticker.Subscribe(this.myEventLog.TickAsync, this.myEventLog);
    }
    cleanupEventLogPanel() {
        if (isNullOrUndefined(this.myEventLog)) {
            return;
        }
        Control.Ticker.UnSubscribe(this.myEventLog.TickAsync, this.myEventLog);
        this.myEventLog = null;
        void this.set({ isEventLogOpened: false });
    }
    eventLogReinit() {
        void this.set({ visible: CustomerAccess.GetDisplayMode(PanelNames.EventsPanel) === PanelDisplayMode.Allowed });
    }
    setEventPanelPos() {
        if (isNullOrUndefined(this.panelOriginalWidth)) {
            // разовое запоминание оригинальных размеров Event Log Panel
            this.panelOriginalWidth = this.myEventLog.get('width');
            this.panelOriginalHeight = this.myEventLog.get('height');
        }
        const eventLogButton = this.find('*').getBoundingClientRect();
        const m = WINDOW_SIDE_BORDERS_WIDTH;
        const w = eventLogButton.left + eventLogButton.width - this.myEventLog.get('width') + m / 2;
        const h = eventLogButton.top - this.myEventLog.get('height') + m / 2;
        this.myEventLog.set({ left: w, top: h });
    }
    setOriginalSize() {
        if (isNullOrUndefined(this.myEventLog)) {
            return;
        }
        this.myEventLog.set('width', this.panelOriginalWidth);
        this.myEventLog.set('height', this.panelOriginalHeight);
        this.setEventPanelPos();
    }
    checkSize() {
        var _a;
        if (isNullOrUndefined(this.myEventLog)) {
            return;
        }
        this.setOriginalSize();
        const top = this.myEventLog.get('top');
        const left = this.myEventLog.get('left');
        const m = WINDOW_SIDE_BORDERS_WIDTH;
        const qt = (_a = this.myEventLog.quickTableRactive) === null || _a === void 0 ? void 0 : _a.quickTable;
        let newWidth = this.myEventLog.get('width');
        let newHeight = this.myEventLog.get('height');
        if (left < 0) {
            newWidth += left - m / 2;
            this.myEventLog.set('width', newWidth);
        }
        if (top < 0) {
            newHeight += top - m / 2;
            this.myEventLog.set('height', newHeight);
        }
        if (!isNullOrUndefined(qt)) {
            qt.width = newWidth;
            qt.height = newHeight;
            qt.onResize();
            this.myEventLog.quickTableRactive.setSizes();
        }
        this.setEventPanelPos();
    }
}
Control.extendWith(TerceraEventLog, {
    template: TerceraEventLogTemplate,
    data: function () {
        return {
            isEventLogOpened: false,
            tooltip: Resources.getResource('panel.log')
        };
    }
});
